module.exports = __webpack_public_path__ + "img/122.8087879b.jpg";